import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const getLang = () => localStorage.getItem("sm-lang") || (navigator.language?.toLowerCase().startsWith("fr") ? "fr" : "en");
export const t = (fr, en) => (getLang() === "en" ? en : fr);
export const locale = () => t("fr-FR", "en-US");

api.interceptors.request.use((cfg) => { cfg.headers["X-Lang"] = getLang(); return cfg; });

let refreshing = null;
const refresh = () => {
  if (!refreshing) refreshing = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
  return refreshing;
};

api.interceptors.response.use(
  (r) => {
    if (r.config.method !== "get" && !r.config.url.includes("/auth/")) window.dispatchEvent(new Event("points-updated"));
    return r;
  },
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try { await refresh(); return api(cfg); } catch (e) { /* fallthrough */ }
    }
    return Promise.reject(error);
  }
);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || t("Une erreur est survenue.", "Something went wrong.");
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export async function streamPost(path, body, onDelta) {
  const doFetch = () => fetch(`${API}${path}`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json", "X-Lang": getLang() }, body: JSON.stringify(body),
  });
  let res = await doFetch();
  if (res.status === 401) { await refresh().catch(() => {}); res = await doFetch(); }
  if (!res.ok) throw new Error(t("La requête a échoué", "The request failed"));
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let full = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const evt = JSON.parse(line.slice(5));
      if (evt.error) throw new Error(evt.error);
      if (evt.delta) { full += evt.delta; onDelta(full); }
    }
  }
  return full;
}

export const CATEGORY_LABELS = {
  get processus() { return t("Processus", "Process"); },
  get produit() { return t("Produit", "Product"); },
  get "bien-etre"() { return t("Bien-être au travail", "Workplace well-being"); },
};
const status = (fr, en, cls) => ({ get label() { return t(fr, en); }, cls });
export const STATUS = {
  soumise: status("Soumise", "Submitted", "bg-slate-100 text-slate-700 border-slate-200"),
  en_etude: status("En étude", "Under review", "bg-amber-50 text-amber-700 border-amber-200"),
  validee: status("Validée", "Approved", "bg-indigo-50 text-indigo-700 border-indigo-200"),
  mise_en_place: status("Mise en place", "Implemented", "bg-emerald-50 text-emerald-700 border-emerald-200"),
  non_retenue: status("Non retenue", "Not retained", "bg-rose-50 text-rose-700 border-rose-200"),
};
export const roleLabel = (r) => ({ employee: t("Collaborateur", "Employee"), manager: "Manager", admin: "Admin" }[r]);
